import React, { useState } from 'react';

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  Collapse,
  Box,
  Typography,
} from '@material-ui/core';

import { CheckCircle, Cancel, KeyboardArrowUp, KeyboardArrowDown } from '@material-ui/icons';
import { green, red } from '@material-ui/core/colors';

export const DefaultRow = (props) => {
  const { row } = props;
  return (
    <React.Fragment>
      <TableRow key={row.criteria}>
        <TableCell />
        <TableCell component="th" scope="row">
          {row.criteria}
        </TableCell>
        <TableCell align="center">{row.requirement}</TableCell>
        <TableCell align="center">{row.value}</TableCell>
        <TableCell align="center">
          {row.status === 'GOOD' ? (
            <CheckCircle style={{color: green[500]}}/>
          ) : (
            <Cancel style={{color: red[500]}}/>
          )}
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

export const CompaniesRow = (props) => {
  const { row } = props;
  const [open, setOpen] = useState(false);

  return (
    <React.Fragment>
      <TableRow >
        <TableCell>
          <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.criteria}
        </TableCell>
        <TableCell align="center">{row.requirement}</TableCell>
        <TableCell align="center">{row.value}</TableCell>
        <TableCell align="center">
          {row.status === 'GOOD' ? (
            <CheckCircle style={{color: green[500]}}/>
          ) : (
            <Cancel style={{color: red[500]}}/>
          )}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Typography variant="h6" gutterBottom component="div">
                {props.title ? props.title : 'Companies'}
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>Name</TableCell>
                    <TableCell align="center">Type</TableCell>
                    <TableCell align="center">Trade</TableCell>
                    <TableCell align="center">Location</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.companies.map((company) => (
                    <TableRow key={company.id}>
                      <TableCell component="th" scope="row">
                        {company.name}
                      </TableCell>
                      <TableCell align="center">{company.type}</TableCell>
                      <TableCell align="center">{company.company_trade}</TableCell>
                      <TableCell align="center">{company.location}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

export const DrawingsRow = (props) => {
  const { row } = props;
  const [open, setOpen] = useState(false);

  return (
    <React.Fragment>
      <TableRow >
        <TableCell>
          <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.criteria}
        </TableCell>
        <TableCell align="center">{row.requirement}</TableCell>
        <TableCell align="center">{row.value}</TableCell>
        <TableCell align="center">
          {row.status === 'GOOD' ? (
            <CheckCircle style={{color: green[500]}}/>
          ) : (
            <Cancel style={{color: red[500]}}/>
          )}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Typography variant="h6" gutterBottom component="div">
                {props.title ? props.title : 'Drawings'}
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>Display Name</TableCell>
                    <TableCell align="center">Created At</TableCell>
                    <TableCell align="center"># Overlays</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.drawings.map((drawing) => (
                    <TableRow key={drawing.id}>
                      <TableCell component="th" scope="row">
                        {drawing.display_name}
                      </TableCell>
                      <TableCell align="center">{drawing.created_at}</TableCell>
                      <TableCell align="center">{drawing.overlays.length}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

export const NonListValueDescriptionTypeRow = (props) => {
  const { row } = props;
  return (
    <React.Fragment>
      <TableRow >
        <TableCell />
        <TableCell component="th" scope="row">
          {row.name}
        </TableCell>
        <TableCell align="center">{row.type}</TableCell>
        <TableCell align="center">{row.order}</TableCell>
        <TableCell align="center">{row.listValues.length}</TableCell>
      </TableRow>
    </React.Fragment>
  );
}

export const ListValueDescriptionTypeRow = (props) => {
  const { row } = props;
  const [open, setOpen] = useState(false);

  return (
    <React.Fragment>
      <TableRow >
        <TableCell>
          <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.name}
        </TableCell>
        <TableCell align="center">{row.type}</TableCell>
        <TableCell align="center">{row.order}</TableCell>
        <TableCell align="center">{row.listValues.length}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Typography variant="h6" gutterBottom component="div">
                {props.title ? props.title : 'List Values'}
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>Value</TableCell>
                    <TableCell align="center">Order</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.listValues.map((listValue) => (
                    <TableRow key={listValue.id}>
                      <TableCell component="th" scope="row">
                        {listValue.value}
                      </TableCell>
                      <TableCell align="center">{listValue.order}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

export const RecordTypeRow = (props) => {
  const { row } = props;
  const [open, setOpen] = useState(false);

  return (
    <React.Fragment>
      <TableRow >
        <TableCell>
          <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.name}
        </TableCell>
        <TableCell align="center">{row.category}</TableCell>
        <TableCell align="center">{row.sub_category}</TableCell>
        <TableCell align="center">{row.descriptions.length}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Typography variant="h6" gutterBottom component="div">
                {props.title ? props.title : 'Descriptions'}
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell />
                    <TableCell>Name</TableCell>
                    <TableCell align="center">Type</TableCell>
                    <TableCell align="center">Order</TableCell>
                    <TableCell align="center"># List Values</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.descriptions.map((description) => {
                    if (description.type === 'list' || description.type === 'button-list') {
                      return (
                        <ListValueDescriptionTypeRow row={description} title={`${description.name} List Values`}/>
                      );
                    }
                    return (<NonListValueDescriptionTypeRow row={description}/>);
                  })}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

export const RecordTypesRow = (props) => {
  const { row } = props;
  const [open, setOpen] = useState(false);

  return (
    <React.Fragment>
      <TableRow >
        <TableCell>
          <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.criteria}
        </TableCell>
        <TableCell align="center">{row.requirement}</TableCell>
        <TableCell align="center">{row.value}</TableCell>
        <TableCell align="center">
          {row.status === 'GOOD' ? (
            <CheckCircle style={{color: green[500]}}/>
          ) : (
            <Cancel style={{color: red[500]}}/>
          )}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Typography variant="h6" gutterBottom component="div">
                {props.title ? props.title : 'Record Types'}
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell />
                    <TableCell>Name</TableCell>
                    <TableCell align="center">Category</TableCell>
                    <TableCell align="center">Subcategory</TableCell>
                    <TableCell align="center"># Descriptions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.recordTypes.map((recordType) => (
                    <RecordTypeRow row={recordType} title={`${recordType.name} Descriptions`}/>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

